// components/modals/SaveSearchModal.js
import React, { useEffect, useState } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { useDispatch } from "react-redux";

const EditSavedSearchModal = ({ show, onHide, updateSavedSearchData, selectedSearch, fetchSavedSearches }) => {

    const dispatch = useDispatch();
    const [searchName, setSearchName] = useState("");

    useEffect(() => {
        if (selectedSearch) {
            setSearchName(selectedSearch.saved_search_name || "");
        }
    }, [selectedSearch]);

    const handleEditSavedSearches = () => {
        const requestPayload = {
            id: selectedSearch?.id,
            saved_search_name: searchName
        }

        const requestOption = {
            method: "PUT",
            mode: "cors",
            headers: HeaderAuthentication.updateAuthOfLeadMerge,
            body: JSON.stringify(requestPayload),
        };
        // console.log(requestPayload, 'requestPayload')
        dispatch(updateSavedSearchData(requestOption, fetchSavedSearches, onHide));
    };

    return (
        <Modal show={show} onHide={onHide} centered className="saved-search-modal">
            <Modal.Header closeButton>
                <Modal.Title>Save Search</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId="searchName">
                    <Form.Label>Search Name</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Enter search name"
                        value={searchName}
                        onChange={(e) => setSearchName(e.target.value)}
                    />
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={handleEditSavedSearches}>
                    Save
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default EditSavedSearchModal;
